export default "__VITE_ASSET__e68a4dbe__"